import React from "react";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import ls from "local-storage";
import RV from "simple-react-validator";
import * as CONFIG from "./_config";
import Modal from "react-bootstrap/Modal";
import { Button, Form } from "react-bootstrap";
import ChangeEmail from "./ChangeEmail";

toast.configure();
const axios = require("axios");

class Myaccount extends React.Component {
  constructor(props) {
    super(props);
    this.validator = new RV();
    this.validator.visibleFields = [];
    this.state = {
      formControls: {
        firstname: "",
        lastname: "",
        client_store: "1",
        email: "",
        barcode: "",
      },
      stores: [],
      changeEmail: false,
    };
  }

  changeHandler = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    this.setState({
      formControls: { ...this.state.formControls, [name]: value },
    });
  };

  handleClose = () => {
    this.setState({ changeEmail: false });
  };

  componentDidMount() {
    this.Stores();
    this.MyAccount();
    ls.set("redirectTo", window.location.href);
  }

  Stores() {
    var ClientStores = ls.get("ClientStores");
    // console.log("storage", ClientStores);

    if (ClientStores) {
      this.setState({ stores: ClientStores });
    } else {
      const data = new FormData();
      data.append("method", "POST");
      let apiurl = "";
      if (CONFIG.DATA.LOAD_STORE_FROM_DIFFERENT_URL) {
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetclientStoresbyClientapp/${CONFIG.DATA.RSA_CLIENT_STORE_GROUP_ID}/''`;
      } else {
        apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetClientStores/1`;
      }

      var object = {};
      data.forEach((value, key) => (object[key] = value));
      var jsonData = JSON.stringify(object);

      axios
        .post(apiurl, jsonData, {
          headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
        })
        .then((res) => {
          // console.log('res',res);
          ls.set("ClientStores", res.data.GetClientStores);
          this.setState({ stores: res.data.GetClientStores });
        })
        .catch(function (response) {
          console.log(response);
        });
    }
  }
  MyAccount() {
    const data = new FormData();
    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : "";

    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/GetMyCardAndSaveAmountInfo/${UserToken}`;

    axios
      .get(apiurl, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        // console.log('res',res);
        this.setState({
          formControls: {
            ...this.state.formControls,
            barcode: res.data.BarCodeUrl,
            client_store: ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
              .ClientStoreId,
            firstname: ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).FirstName,
            lastname: ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).LastName,
            MobileNumber: ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
              .MobileNumber,
          },
        });
      })
      .catch(function (response) {
        console.log(response);
      });
  }

  UpdateAccount = async (e) => {
    // console.log(e);

    e.preventDefault();

    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
      return false;
    }

    var UserToken = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`)
      ? ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`).UserToken
      : "";
    const data = new FormData();
    data.append("method", "POST");
    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/UpdateUserProfile`;

    data.append("FirstName", this.state.formControls.firstname);
    data.append("LastName", this.state.formControls.lastname);
    data.append("PhoneNumber", this.state.formControls.MobileNumber);
    data.append("ClientStoreId", this.state.formControls.client_store);
    data.append("UserToken", UserToken);

    var object = {};
    data.forEach((value, key) => (object[key] = value));
    var jsonData = JSON.stringify(object);

    axios
      .post(apiurl, jsonData, {
        headers: { domainname: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        if (res.data.ErrorMessage.ErrorCode <= 0) {
          toast.error(res.data.ErrorMessage.ErrorDetails);
        } else {
          toast.success("Profile Updated Successfully !", { autoClose: 2000 });
          // window.location.href = "/login";

          var user = ls.get(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`);
          // console.log(ls.get('userdata'),'user');

          user["ClientStoreId"] = this.state.formControls.client_store;
          user["FirstName"] = this.state.formControls.firstname;
          user["LastName"] = this.state.formControls.lastname;

          user["MobileNumber"] = this.state.formControls.MobileNumber;

          ls.set(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`, user);
          // console.log(ls.get('userdata'),'user');
        }
      })
      .catch(function (ress) {
        console.log(ress);
        toast.error("Error Notification !");
      });
  };

  logout() {
    var redirectTo = ls.get("redirectTo");
    ls.remove(`userdata${CONFIG.DATA.RSA_SUBDOMAIN}`);
    ls.remove("ClientStores");
    ls.remove("Departments");
    ls.clear();

    this.props.history.push("/login");
    // this.showLogin();

    ls.set("redirectTo", redirectTo);
    window.location.reload();
  }

  DeleteAccount = async () => {
    const MemberNumber = localStorage.getItem("MemberNumber");
    const UserDetailId = localStorage.getItem("UserDetailId");
    const UserToken = localStorage.getItem("UserToken");

    const reqData = {
      MemberNumber: MemberNumber,
      UserDetailId: UserDetailId,
      UserToken: UserToken.replaceAll(`\"`, ""),
    };
    const apiurl = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/DeleteUser`;
    await axios
      .post(apiurl, reqData, {
        headers: { DomainName: CONFIG.DATA.RSA_SUBDOMAIN },
      })
      .then((res) => {
        console.log(res.data.ErrorMessage.ErrorCode);
        if (res.data.ErrorMessage.ErrorCode !== 1) {
          toast(res.data.ErrorMessage.ErrorDetails);
        } else {
          toast("User deleted successfully");
          setTimeout(() => {
            this.logout();
          }, 2000);
        }
      })
      .catch((err) => {
        console.log(err.response);
        toast(err.response.data);
      });
  };

  render() {
    return (
      <div className="main-container full-width pt-5 mt-5">
        {CONFIG.DATA.THEME === 2 ? (
          <section
            id="apus-breadscrumb"
            className="breadcrumb-page apus-breadscrumb"
            style={{ backgroundColor: "#f3ffd9" }}
          >
            <div className="container">
              <div className="wrapper-breads">
                <div className="wrapper-breads-inner">
                  <div className="breadscrumb-inner">
                    <h2 className="bread-title">My Account</h2>
                    <ol className="breadcrumb">
                      <li>
                        <a href={CONFIG.DATA.BASEPATH}>Home</a>
                      </li>
                      <li>
                        <span className="active">My Account</span>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <div className="title-breadcrumb">
            <div className="container">
              <div className="title-breadcrumb-inner">
                <header className="entry-header">
                  <h1 className="entry-title">Account Details</h1>
                </header>
                <div className="breadcrumbs">
                  <Link to="/">Home</Link>
                  <span className="separator">/</span>
                  <span> My Account</span>
                </div>
              </div>
            </div>
          </div>
        )}
        <div className="page-content">
          <div className="container">
            <article
              id="post-22"
              className="post-22 page type-page status-publish hentry"
            >
              <div className="entry-content">
                <div
                  className="vc_row wpb_row vc_row-fluid"
                  style={{ marginTop: "40px" }}
                >
                  <div
                    className="row-container"
                    style={{
                      border: "1px solid #d3ced2",
                      padding: 20,
                      margin: "2em 0",
                      textAlign: "left",
                      borderRadius: 5,
                      width: "800px",
                      margin: "1rem auto",
                    }}
                  >
                    <div className="wpb_column vc_column_container vc_col-sm-12">
                      <div className="vc_column-inner">
                        <div className="wpb_wrapper">
                          <div className="wpforms-container wpforms-container-full">
                            <div className="woocommerce-notices-wrapper" />
                            <form
                              method="post"
                              className="wpforms-validate wpforms-form"
                              role="form"
                            >
                              <p className="form-group form-row form-row-wide">
                                <img
                                  alt="Barcode"
                                  src={
                                    this.state.formControls.barcode === ""
                                      ? "/assets/images/loading.gif"
                                      : this.state.formControls.barcode
                                  }
                                  style={{ margin: "0px auto" }}
                                  className="img-responsive"
                                />
                              </p>

                              <div className="wpforms-field-container">
                                <div
                                  id="wpforms-8464-field_1-container"
                                  className="wpforms-field wpforms-field-text wpforms-one-half wpforms-first"
                                  data-field-id="1"
                                >
                                  <label
                                    className="wpforms-field-label"
                                    htmlFor="wpforms-8464-field_1"
                                  >
                                    First Name
                                    <span className="wpforms-required-label">
                                      *
                                    </span>
                                  </label>
                                  <input
                                    onChange={(e) => this.changeHandler(e)}
                                    type="text"
                                    id="firstname"
                                    className="wpforms-field-large wpforms-field-required"
                                    name="firstname"
                                    required="required"
                                    value={this.state.formControls.firstname}
                                  />
                                  <span className="text-danger float-left">
                                    {this.validator.message(
                                      "first name",
                                      this.state.formControls.firstname,
                                      "required"
                                    )}
                                  </span>
                                </div>
                                <div
                                  id="wpforms-8464-field_2-container"
                                  className="wpforms-field wpforms-field-text wpforms-one-half"
                                  data-field-id="2"
                                >
                                  <label
                                    className="wpforms-field-label"
                                    htmlFor="wpforms-8464-field_2"
                                  >
                                    Last Name
                                    <span className="wpforms-required-label">
                                      *
                                    </span>
                                  </label>
                                  <input
                                    onChange={(e) => this.changeHandler(e)}
                                    type="text"
                                    className="wpforms-field-large wpforms-field-required"
                                    name="lastname"
                                    id="lastname"
                                    value={this.state.formControls.lastname}
                                  />
                                  <span className="text-danger float-left">
                                    {this.validator.message(
                                      "last name",
                                      this.state.formControls.lastname,
                                      "required"
                                    )}
                                  </span>
                                </div>

                                <div
                                  id="wpforms-8464-field_3-container"
                                  className="wpforms-field wpforms-field-text wpforms-one-half wpforms-first"
                                  data-field-id="3"
                                >
                                  <label
                                    className="wpforms-field-label"
                                    htmlFor="wpforms-8464-field_3"
                                  >
                                    Email Address
                                    <span className="wpforms-required-label">
                                      *
                                    </span>
                                  </label>
                                  <input
                                    onChange={this.changeHandler}
                                    type="email"
                                    id="username"
                                    className="wpforms-field-large wpforms-field-required"
                                    name="username"
                                    required=""
                                    readOnly
                                    value={
                                      ls.get(
                                        `userdata${CONFIG.DATA.RSA_SUBDOMAIN}`
                                      ).Username
                                    }
                                  />
                                </div>
                                <div
                                  id="wpforms-8464-field_3-container"
                                  className="wpforms-field wpforms-field-email wpforms-one-half"
                                  data-field-id="3"
                                >
                                  {CONFIG.DATA
                                    .ALLOW_CHANGE_CUSTOMER_EMAIL_ID && (
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                        color: "red",
                                        position: "relative",
                                        top: "2.2rem",
                                      }}
                                      onClick={() => {
                                        this.setState({
                                          changeEmail: true,
                                        });
                                      }}
                                    >
                                      Change
                                    </span>
                                  )}
                                </div>
                                <div
                                  id="wpforms-8464-field_1-container"
                                  className="wpforms-field wpforms-field-text wpforms-one-half wpforms-first"
                                  data-field-id="1"
                                ></div>

                                <ChangeEmail
                                  handleClose={this.handleClose}
                                  changeEmail={this.state.changeEmail}
                                />

                                <div
                                  id="wpforms-8464-field_3-container"
                                  className="wpforms-field wpforms-field-text wpforms-one-half wpforms-first"
                                  data-field-id="3"
                                >
                                  <label
                                    className="wpforms-field-label"
                                    htmlFor="wpforms-8464-field_3"
                                  >
                                    Phone Number
                                    <span className="wpforms-required-label">
                                      *
                                    </span>
                                  </label>
                                  <input
                                    onChange={this.changeHandler}
                                    type="text"
                                    id="MobileNumber"
                                    className="wpforms-field-large wpforms-field-required"
                                    name="MobileNumber"
                                    maxLength="10"
                                    value={this.state.formControls.MobileNumber}
                                  />
                                </div>

                                <div
                                  id="wpforms-8464-field_3-container"
                                  className="wpforms-field wpforms-field-email wpforms-one-half"
                                  data-field-id="3"
                                >
                                  <label
                                    className="wpforms-field-label"
                                    htmlFor="client_store"
                                  >
                                    Preferred Store
                                    <span className="wpforms-required-label">
                                      *
                                    </span>
                                  </label>
                                  <select
                                    className="wpforms-field-large wpforms-field-required"
                                    id="client_store"
                                    name="client_store"
                                    value={this.state.formControls.client_store}
                                    onChange={(e) => this.changeHandler(e)}
                                  >
                                    <option value="">Select</option>
                                    {this.state.stores.map((value, index) => (
                                      <option
                                        key={index}
                                        value={value.ClientStoreId}
                                      >
                                        {value.ClientStoreName}
                                      </option>
                                    ))}
                                  </select>
                                  <span className="text-danger display-block float-left">
                                    {this.validator.message(
                                      "Preferred Store",
                                      this.state.formControls.client_store,
                                      "required"
                                    )}
                                  </span>
                                </div>
                                <div
                                  id="wpforms-8464-field_3-container"
                                  className="wpforms-field wpforms-field-email wpforms-one-third wpforms-first"
                                  data-field-id="3"
                                >
                                  <button
                                    type="submit"
                                    name="update_profile_btn"
                                    className="wpforms-submit btn btn-success mr-1"
                                    id="update_profile_btn"
                                    value="wpforms-submit"
                                    aria-live="assertive"
                                    data-alt-text="Sending..."
                                    data-submit-text="Update Profile"
                                    onClick={(e) => this.UpdateAccount(e)}
                                  >
                                    Submit
                                  </button>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {CONFIG.DATA.ALLOW_DELETE_USER && (
                    <div
                      className="row-container"
                      style={{
                        border: "1px solid #d3ced2",
                        padding: 20,
                        margin: "2em 0",
                        textAlign: "left",
                        borderRadius: 5,
                        width: "800px",
                        margin: "1rem auto",
                      }}
                    >
                      <h3>Delete Account</h3>
                      <p>
                        By deleting the account you will not be able to login to
                        our app or website. All your profile information,
                        clipped info, purchases, rewards, points will be deleted
                        and will not be able restore the deleted account.
                      </p>
                      <p>
                        If you are sure to delete the account, please click the
                        Delete Account button below and confirm.
                      </p>
                      <button
                        className="btn-success btn"
                        onClick={() => {
                          console.log(localStorage.getItem("UserToken"));
                          let text =
                            "Are you sure you want to delete this account?";
                          if (window.confirm(text) === true) {
                            this.DeleteAccount();
                          } else {
                            console.log("Cancelled");
                          }
                        }}
                      >
                        Delete Account
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    );
  }
}
export default Myaccount;
